export const POINTER_EVENTS = {
  auto: 'auto',
  none: 'none',
} as const;
export type PointerEvent = (typeof POINTER_EVENTS)[keyof typeof POINTER_EVENTS];
